import {
  CLUB_PROGRAMME_STATUS_OPTIONS,
  CLUB_PROGRAMME_SELECTION_MODE_OPTIONS,
  CLUB_PROGRAMME_PREBOOKING_ACCESS_OPTIONS
} from 'Src/consts/clubProgramme';

type BuildActionItemsParams = {
  selectedItemsCount: number;
  canEdit: boolean;
  canActivate: boolean;
  canDelete: boolean;
  onCreate: () => void;
  onEdit: () => void;
  onActivate: () => void;
  onDelete: () => void;
  activateDisabledReason?: string;
};

export const buildClubProgrammesActionItems = ({
  selectedItemsCount,
  canEdit,
  canActivate,
  canDelete,
  onCreate,
  onEdit,
  onActivate,
  onDelete,
  activateDisabledReason
}: BuildActionItemsParams) => {
  return [
    {
      itemText: 'Create programme',
      onItemClick: onCreate,
      isActive: selectedItemsCount === 0
    },
    {
      itemText: 'Edit programme',
      onItemClick: onEdit,
      isActive: canEdit
    },
    {
      itemText: canActivate
        ? selectedItemsCount === 1
          ? 'Activate programme'
          : 'Activate programmes'
        : `${selectedItemsCount === 1 ? 'Activate programme' : 'Activate programmes'}${
            activateDisabledReason ? ` (${activateDisabledReason})` : ''
          }`,
      onItemClick: onActivate,
      isActive: canActivate
    },
    {
      itemText: selectedItemsCount === 1 ? 'Delete programme' : 'Delete programmes',
      onItemClick: onDelete,
      isActive: canDelete
    }
  ];
};

export const buildClubProgrammesFilterOptions = () => {
  return {
    status: CLUB_PROGRAMME_STATUS_OPTIONS.map(x => ({ value: x, text: x })),
    selectionMode: CLUB_PROGRAMME_SELECTION_MODE_OPTIONS.map(x => ({ value: x, text: x })),
    preBookingAccess: CLUB_PROGRAMME_PREBOOKING_ACCESS_OPTIONS.map(x => ({ value: x, text: x }))
  };
};
